import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { SortBoulderListPipe } from 'src/pipes/sort-boulder-list.pipe';
import { BoulderService } from 'src/services/boulder.service';
import { BBStorage } from 'src/utils/bb-storage';
import { BoulderDetailsPage } from '../boulder-details/boulder-details.page';
import { RankingService } from 'src/services/ranking.service';
import { Boulder } from 'src/model/boulder';
import { AscentListEntry } from 'src/model/ascent-list-entry';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  bouldersCreatedByUser: Boulder[] = [];
  bouldersSentByUser: Boulder[] = [];
  allBoulders: Boulder[] = [];
  ascentsOfUser: AscentListEntry[] = [];
  public username: string;
  public listType: string = 'ascents';
  public boulderRank: number = 0;
  public creatorRank: number = 0;
  public numberOfOwnBouldersUpgraded = 0;
  public percentOwnBouldersUpgraded = 0;
  public numberOfOwnBouldersDowngraded = 0;
  public percentOfOwnBouldersDowngraded = 0;
  public avarageThumbUps = 0;
  public isLoading = false;

  constructor(
    private bbStorage: BBStorage,
    private rankingService: RankingService,
    private modalCtrl: ModalController,
    private boulderService: BoulderService,
    private activatedRoute: ActivatedRoute) {
  }

  private async reloadBoulders() {
    this.allBoulders = (await firstValueFrom(this.boulderService.getBoulders$()))
    SortBoulderListPipe.sortBoulderList(this.allBoulders, this.bbStorage.boulderListSortType);
    this.bouldersCreatedByUser = this.allBoulders.filter(b => b.author == this.username);
    this.bouldersSentByUser = this.allBoulders.filter(b => b.ascents.filter(a => a.userName == this.username).length > 0);
    this.ascentsOfUser = this.allBoulders.map(b => b.ascents.filter(a => a.userName == this.username)[0]).filter(a => a);
  }

  async showBoulder(boulderId: string) {
    const modal = await this.modalCtrl.create({
      component: BoulderDetailsPage,
      componentProps: { boulderId: boulderId, boulderIds: this.bouldersCreatedByUser.map(b => b.boulderId) }
    });
    return await modal.present();
  }

  ngOnInit() {
    if (!this.username) {
      this.username = this.activatedRoute.snapshot.paramMap.get('username');
    }
    this.reload();
  }

  public async reload() {
    this.isLoading = true;
    try {
      await this.reloadBoulders();
      this.boulderRank = this.rankingService.calculateBouldererRating(this.allBoulders).filter(r => r.user === this.username)[0]?.rank;
      this.creatorRank = this.rankingService.calculateCreatorRating(this.allBoulders).filter(r => r.user === this.username)[0]?.rank;
      this.numberOfOwnBouldersUpgraded = this.bouldersCreatedByUser.filter(b => {
        const personalGrade = b.ascents.filter(a => a.userName === this.username && a.personalGrade).map(a => a.personalGrade)[0];
        if (personalGrade) {
          return personalGrade < b.grade
        }
        return false;
      }).length
      this.numberOfOwnBouldersDowngraded = this.bouldersCreatedByUser.filter(b => {
        const personalGrade = b.ascents.filter(a => a.userName === this.username && a.personalGrade).map(a => a.personalGrade)[0];
        if (personalGrade) {
          return personalGrade > b.grade
        }
        return false;
      }).length
      this.percentOfOwnBouldersDowngraded = Math.round((this.numberOfOwnBouldersDowngraded / this.bouldersCreatedByUser.length * 100) || 0);
      this.percentOwnBouldersUpgraded = Math.round((this.numberOfOwnBouldersUpgraded / this.bouldersCreatedByUser.length * 100) || 0);

      const thumbs = this.bouldersCreatedByUser.filter(b => b.ascents.filter(a => a.userName !== this.username).length > 0).map(b => {
        return b.quality.numThumbsUp - b.quality.numThumbsDown;
      });
      const sumThumbs = thumbs.reduce((a, b) => a + b, 0);
      this.avarageThumbUps = Math.round((sumThumbs / thumbs.length) || 0);
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * If there is a modal, we assume this page is part of it and dismiss it.
   */
  async backButtonPressed() {
    const top = await this.modalCtrl.getTop();
    if (top) {
      await top.dismiss();
    }
  }

  listTypeChanged($event: any) {
    this.listType = $event.detail.value;
  }
}
